'use strict';
module.exports = Backbone.Model.extend({
    defaults: {
        bookingID: null,
    },
});
